/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-10 17:03:58
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-03-02 16:52:58
 * @Description: file content
 */

Vue.component("encourage_box", {
  props: {
  },
  template: `<div v-if="isGetDataComplete" class="encourage_box">
  <div class="encourage_box_mask">
    <div class="encourage_box_content">

      <div class="btn">
        <img @click="clickBtn" :src="btnImgUrl"/>
      </div>
      <div class="tips">{{tips}}</div>
      
      <div class="close">
        <img @click="clickClose" src='https://assets.rurushishi.com/yq-rs-h5/encourage_box_close.png'/>
      </div>
    </div>
  </div>
</div>`,
  data() {
    return {
      isGetDataComplete: false,
      inviteCount: 0,// 推荐数
      myGiftCount: 0,// 获得礼品数
      marktingSalesLeadCount: 0,// 线索数
      waitingInviteCount: 0,//待推荐的数量
      isSubscribe: 0,//是否关注
      btnImgUrl: '',
      btnType: '',// subscribe share select
      tips: '',
    }
  },
  methods: {
    clickGotoInvitePage() {
      location.href = `${location.protocol}//${location.host}/marketies/${wj.browser.versions.wxwork ? 'qwdesk' : 'desk'}/pages/encourage/invite`;
    },
    clickShowShare() {
      window.myVue.isShowShareGuide3 = true;
    },
    clickClose: function () {
      this.$emit("close");
    },
    clickBtn() {
      switch (this.btnType) {
        case 'subscribe':
          $(".wx-qrcode").removeClass("hide");
          break;
        case 'share':
          this.clickShowShare();
          break;
        case 'select':
          this.clickGotoInvitePage();
          break;
      }
    }
  },
  created() {
    this.isSubscribe = myTemp.issubscribe;

    comreq.getMyInviteCount().then(res => {
      if (res.code === 0) {
        this.inviteCount = res.data.inviteCount;
        this.myGiftCount = res.data.myGiftCount;
        this.marktingSalesLeadCount = res.data.marktingSalesLeadCount;
        this.waitingInviteCount = this.marktingSalesLeadCount - this.inviteCount;

        if (!this.isSubscribe) {
          this.btnImgUrl = "https://assets.rurushishi.com/yq-rs-h5/encourage_box/btn_subscribe.png"
          this.btnType = 'subscribe';
          this.tips = '关注公众号及时接收领奖信息!';
        } else if (this.waitingInviteCount > 0) {
          this.btnImgUrl = "https://assets.rurushishi.com/yq-rs-h5/encourage_box/btn_select.png";
          this.btnType = 'select';
          this.tips = `恭喜您，新发现${this.waitingInviteCount}个好友对该内容感兴趣，快来给他赠送礼品吧！`;
        } else {
          this.btnImgUrl = "https://assets.rurushishi.com/yq-rs-h5/encourage_box/btn_share.png";
          this.btnType = 'share';
          this.tips = '传播文章给好友，领取丰厚奖品吧！';
        }
      }
      this.isGetDataComplete = true;
      biz.handlerYqAnalyticsEvent('showNoThreshold')
    })
  }
})
